import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getAllStudent = para => requestActionMaker({ cons: cons.GET_ALL_STUDENT, api: apis.getAllStudent, ...para });
export const getStudent = para => requestActionMaker({ cons: cons.GET_STUDENT, api: apis.getStudent, ...para });
export const createStudent = para => requestActionMaker({ cons: cons.CREATE_STUDENT, api: apis.createStudent, ...para });
export const updateStudent = para => requestActionMaker({ cons: cons.UPDATE_STUDENT, api: apis.updateStudent, ...para });
export const getStudentsForSelection = para => requestActionMaker({ cons: cons.GET_STUDENTS_FOR_SELECTION, api: apis.getAllStudent, ...para });